import { UserAdapters } from '../adapters';
import { MAX_USER_IDS_PER_REQUEST, UsersApi } from '../clients';
import { toBatches } from './toBatches';

// auth-service 400s the whole request when any id is not a Mongo ObjectId, so
// one malformed id would otherwise cost every user in its batch.
const OBJECT_ID = /^[0-9a-f]{24}$/i;

/**
 * Users by id, in as many requests as auth-service's id cap needs. Ids it
 * would refuse are left out rather than sent. An empty list sends nothing:
 * `userIds=` alone is no filter, and would answer with every user there is.
 *
 * @param {string[]} userIds
 * @returns {Promise<import('../types/User').IGetUsersByIdsResult>}
 */
export const getUsersByIds = async (userIds) => {
  const batches = toBatches(userIds.filter((id) => OBJECT_ID.test(id)), MAX_USER_IDS_PER_REQUEST);
  const responses = await Promise.all(batches.map((batch) => UsersApi.getUsersByIds(batch)));

  return {
    data: responses.flatMap((response) => UserAdapters.toGetUsersByIdsResult(response).data),
  };
};
